import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { HeaderNavigation } from '@/components/HeaderNavigation'

export interface HeaderWithTitleAndDescriptionProps {
  /** Заголовок страницы */
  title: string
  /** Описание под заголовком */
  description?: string
  /** Обработчик нажатия на кнопку назад */
  onBackPress?: () => void
  /** Показывать ли кнопку назад */
  showBackButton?: boolean
  /** Горизонтальные отступы для контента */
  contentPadding?: number
  /** Дополнительные стили для контейнера */
  containerStyle?: React.CSSProperties
  /** Дополнительные компоненты для отображения после описания */
  children?: React.ReactNode
}

export const HeaderWithTitleAndDescription: React.FC<
  HeaderWithTitleAndDescriptionProps
> = ({
  title,
  description,
  onBackPress,
  showBackButton = true,
  contentPadding = 13,
  containerStyle = {},
  children,
}) => {
  return (
    <HeaderNavigation
      onBackPress={onBackPress}
      showBackButton={showBackButton}
      isFixed={true}
      showBackground={true}
      containerStyle={containerStyle}
    >
      {/* Title and Description */}
      <BaseView px={contentPadding} gap={10}>
        <BaseText
          style={{ whiteSpace: 'nowrap' }}
          fontSize={28}
          fontFamily="semibold"
          color="label.default"
        >
          {title}
        </BaseText>

        {description && (
          <BaseText lineHeight={20} color="label.disabled">
            {description}
          </BaseText>
        )}

        {/* Additional components */}
        {children}
      </BaseView>
    </HeaderNavigation>
  )
}
